import api from '@/utils/httpClient';
import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery, UseQueryOptions } from 'react-query';
import { workflowKeys } from './workflow.keys';

enum ExpertAssignment {
	NoAssignment = 'No Assignment',
	RequiredAssignment = 'Required Assignment',
	OptionalAssignment = 'Optional Assignment',
	Unknown = 'Unknown'
}

enum ImagingSupport {
	SupportsDicom = 'Supports Dicom',
	NoSupport = 'No Support',
	Unknown = 'Unknown'
}

enum AttachmentsSupport {
	SupportsAllAttachments = 'Supports All Attachments',
	NoSupport = 'No Support',
	Unknown = 'Unknown'
}

export interface WorkflowDto {
	id: string;
	expertAssignment: ExpertAssignment;
	imagingSupport: ImagingSupport;
	attachmentsSupport: AttachmentsSupport;
	organizationId: string;
}

export class WorkflowUtilities {
	static shouldShowDicomImaging(workflow?: WorkflowDto) {
		return (
			workflow?.imagingSupport === ImagingSupport.SupportsDicom
		);
	}
	static shouldShowAttachments(workflow?: WorkflowDto) {
		return workflow?.attachmentsSupport === AttachmentsSupport.SupportsAllAttachments;
	}
	static shouldShowImagingAndAttachmentsSection(workflow?: WorkflowDto) {
		return (
			WorkflowUtilities.shouldShowDicomImaging(workflow) || WorkflowUtilities.shouldShowAttachments(workflow)
		);
	}
}

async function getWorkflow(workflowId: string) {
  return api
    .get(`/api/collaborationworkflows/${workflowId}`)
    .then((response) => (response.data as ApiResponse<WorkflowDto>).data);
}

interface UseRequestWorkflowArguments {
	id: string;
	options?: UseQueryOptions<WorkflowDto>;
}

function useWorkflow({ id, options = {} }: UseRequestWorkflowArguments) {
  return useQuery(workflowKeys.detail(id), async () => getWorkflow(id), options);
}

export { getWorkflow, useWorkflow };
